import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('quote', '/plans/quotes', 'quote')
const actions = generator.generate()

export default actions
